import { css } from '@emotion/react';
import PropTypes from 'prop-types';
import ReactRouterLink from '../../components/ReactRouterLink';
import Button from '../../components/Button';
import useMessageService from '../../services/i18n/useMessageService';
import EmailField from '../../components/EmailField';
import getTargetAttribute from '../../services/getTargetAttribute';
import { UnauthenticatedPaths } from '../../constants/Paths';

const PasswordResetForm = ({
    onResetPassword,
    onInputChange,
    email,
    emailErrorMessage,
    requestStateParams,
}) => {
    const [
        [
            resetPasswordLabel = 'Reset Your Password',
            resetPasswordMessage = 'We will send you an email with instructions on how to reset your password.',
            placeholderText = 'Enter Email',
            backLabel = 'Back',
        ],
    ] = useMessageService([
        'forgot_password.reset_password',
        'forgot_password.how_to_reset',
        'forgot_password.email_placeholder',
        'general.back',
    ]);

    return (
        <>
            <div
                css={css`
                    margin-bottom: 1.666rem;
                    text-align: center;
                `}
            >
                {resetPasswordMessage}
            </div>
            <EmailField
                onChange={onInputChange}
                value={email}
                errorMessage={emailErrorMessage}
                placeholder={placeholderText}
                onKeyUp={onResetPassword}
            />
            <Button
                onClick={onResetPassword}
                disabled={!email}
                data-target={getTargetAttribute('submit-button')}
            >
                {resetPasswordLabel}
            </Button>
            <div
                css={css`
                    margin-top: 2.667rem;
                    text-align: center;
                `}
            >
                <ReactRouterLink
                    css={css`
                        font-size: 1.333rem;
                    `}
                    to={{
                        pathname: UnauthenticatedPaths.LOGIN,
                        search: requestStateParams,
                    }}
                >
                    {backLabel}
                </ReactRouterLink>
            </div>
        </>
    );
};

PasswordResetForm.propTypes = {
    email: PropTypes.string,
    emailErrorMessage: PropTypes.string,
    onInputChange: PropTypes.func,
    onResetPassword: PropTypes.func,
    requestStateParams: PropTypes.string,
};

export default PasswordResetForm;
